var voucher = "https://shopfront-cdn.tekoapis.com/static/90b396a842b085f8.svg";

export { voucher as default };
